import apolloClient from "@/apollo/apollo";
import gql from "graphql-tag";

const state = {
    branches: [],
    branch: null
};

const getters = {
    getAllBranches: (state) => state.branches,
    getSingleBranch: (state) => state.branch,
};

const mutations = {
    setAllBranches(state, branches) {
        state.branches = branches;
    },
    setSingleBranch(state, branch) {
        state.branch = branch;
    }
};

const actions = {
    async fetchAllBranches({ commit }, status) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findAllBranches($status: BranchStatusEnum) {
                        findAllBranches(status: $status) {
                            id
                            name
                            status
                            address
                            caseManagerId
                            caseManager {
                                id
                                email
                                contact {
                                    fullName
                                    firstName
                                    lastName
                                }
                            }
                            medicalDirectorId
                            medicalDirector {
                                id
                                email
                                contact {
                                    fullName
                                    firstName
                                    lastName
                                }
                            }
                        }
                    }
                `,
                variables: { status },
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            commit('setAllBranches', response.data.findAllBranches);
        } catch (error) {
            console.error("Failed to fetch branches:", error);
        }
    },

    async fetchSingleBranch({ commit }, id) {
        try {
            const response = await apolloClient.query({
                query: gql`
                    query findOneBranchById($id: Int!) {
                        findOneBranchById(id: $id) {
                            id
                            name
                            status
                            address
                            caseManagerId
                            caseManager {
                                id
                                email
                                contact {
                                    fullName
                                    firstName
                                    lastName
                                }
                            }
                            medicalDirectorId
                            medicalDirector {
                                id
                                email
                                contact {
                                    fullName
                                    firstName
                                    lastName
                                }
                            }
                        }
                    }
                `,
                variables: {
                    id: +id
                },
                fetchPolicy: 'network-only',
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            if (response.data) {
                commit('setSingleBranch', response.data.findOneBranchById);
            }
        } catch (error) {
            console.error("Failed to fetch branch:", error);
        }
    },

    async createBranch({ commit, dispatch }, payload) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation createBranch($branchInput: BranchInput!) {
                        createBranch(branchInput: $branchInput) {
                            id
                            name
                            caseManagerId
                            medicalDirectorId
                        }
                    }
                `,
                variables: {
                    branchInput: payload
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            dispatch('fetchAllBranches');
        } catch (error) {
            console.error("Failed to create branch:", error);
            throw error;
        }
    },

    async updateBranch({ commit, dispatch }, { id, payload }) {
        try {
            await apolloClient.mutate({
                mutation: gql`
                    mutation updateBranch($id: Int!, $branchInput: BranchInput!) {
                        updateBranch(id: $id, branchInput: $branchInput) {
                            id
                            name
                            caseManagerId
                            medicalDirectorId
                        }
                    }
                `,
                variables: {
                    id: +id,
                    branchInput: payload
                },
                context: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
                    },
                }
            });
            dispatch('fetchAllBranches');
        } catch (error) {
            console.error("Failed to update branch:", error);
            throw error;
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
};
